import React, { useState, useEffect } from "react";
import {
    Typography,
    Button,
    TextField,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Box,
    Paper
} from "@mui/material";
import HeaderDashboard from "../../components/HeaderDashboard";
import { useUser } from "../../../contexts/UserContext";
import ReceiptIcon from '@mui/icons-material/Receipt';
import IconButton from '@mui/material/IconButton';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import Tooltip from '@mui/material/Tooltip';
import HomeIcon from '@mui/icons-material/Home';
import { useNavigate } from "react-router-dom";
import ModalNotificacao from "./ModalNotificacao";
import axios from "axios";
import FormatDateHour from "../../../utils/FormatDateHour";
import CancelIcon from '@mui/icons-material/Cancel';
import Pagination from '@mui/material/Pagination';
import { MascaraValor } from "../../../utils/MascaraValor";
import Loading from "../../components/Loading";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import AlertError from "../../components/AlertError";
import { Breadcrumbs, Link } from "@mui/material";
import AlertSuccess from "../../components/AlertSuccess";


const NotasFiscaisEmitidas = () => {
    const { user } = useUser();
    const navigate = useNavigate();

    const [userActive, setUserActive] = useState(true);
    const [openModalNotificacao, setOpenModalNotificacao] = useState(false);
    const [notificacoes, setNotificacoes] = useState([]);
    const [open, setOpen] = useState(false);
    const [openSnackbarError, setOpenSnackbarError] = useState(false);
    const [mensagem, setMensagem] = useState("");
    const [openSnackbarSuccess, setOpenSnackbarSuccess] = useState(false);
    const [dataInicial, setDataInicial] = useState("");
    const [dataFinal, setDataFinal] = useState("");
    const [statusFiltro, setStatusFiltro] = useState("");
    const [filteredNotas, setFilteredNotas] = useState([]);

    useEffect(() => {
        if (user?.listNotasFiscaisEmitidas) {
            setFilteredNotas(user.listNotasFiscaisEmitidas);
        }
    }, [user?.listNotasFiscaisEmitidas]);

    useEffect(() => {
        // Verifica se o usuário está com servico vencida
        const hasservicosVencidas = user?.servicos?.vencidas?.length > 0;

        if (hasservicosVencidas) {
            setUserActive(false);
        } else {
            setUserActive(true);
        }
    }, [user]);

    useEffect(() => {
        const getNotify = async () => {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/buscarNotificacoes`, { email: localStorage.getItem("email") }, {
                headers: {
                    Authorization: `${localStorage.getItem("token")}`
                }
            });

            if (response.data.status === 200) {
                setNotificacoes(response.data.notificacoes)
            }
        }

        getNotify();
    }, [])

    const handleCancelNota = async (idIntegracao) => {
        try {
            setOpen(true);
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/cancelarNotaFiscal`, { idIntegracao }, {
                headers: {
                    Authorization: `${localStorage.getItem("token")}`
                }
            });
            console.log(response.data);
            setMensagem("Nota fiscal cancelada com sucesso.");
            setOpenSnackbarSuccess(true);
        } catch (error) {
            setMensagem("Erro ao cancelar a nota fiscal. Por favor, tente novamente mais tarde.");
            setOpenSnackbarError(true);
            // console.error("Erro ao cancelar nota fiscal:", error);
        } finally {
            // Atualiza a lista de notas fiscais após o cancelamento
            setOpen(false);
        }
    }

    const itemsPerPage = 10; // Número de itens por página
    // Definindo o estado para a página atual e os itens por página
    const [currentPage, setCurrentPage] = useState(1);

    const start = (currentPage - 1) * itemsPerPage;
    const end = start + itemsPerPage;

    const itemsPaginated = filteredNotas?.slice(start, end);

    const faturamentoMensal = user?.listNotasFiscaisEmitidas?.reduce((total, nota) => {
        const dataEmissao = new Date(nota.dataEmissao);
        const hoje = new Date();
        if (dataEmissao.getMonth() === hoje.getMonth() && dataEmissao.getFullYear() === hoje.getFullYear() && nota.status === "CONCLUIDO") {
            return total + Number(nota.valor);
        }
        return total;
    }, 0) || 0;

    const pendencias = user?.listNotasFiscaisEmitidas?.filter((nota) => nota.status === "PENDENTE").length || 0;

    const handleFilter = () => {
        const dataInicialObj = dataInicial ? new Date(dataInicial) : null;
        const dataFinalObj = dataFinal ? new Date(dataFinal) : null;
        const filteredNotas = user?.listNotasFiscaisEmitidas?.filter((nota) => {
            const dataEmissao = new Date(nota.dataEmissao);
            const statusMatch = statusFiltro && statusFiltro !== "TODAS" ? nota.status === statusFiltro : true;
            const dataInicialMatch = dataInicialObj ? dataEmissao >= dataInicialObj : true;
            const dataFinalMatch = dataFinalObj ? dataEmissao <= dataFinalObj : true;
            return statusMatch && dataInicialMatch && dataFinalMatch;
        });
        console.log("Notas filtradas:", filteredNotas);
        setFilteredNotas(filteredNotas);
    }

    return (
        <>
            <HeaderDashboard userActive={userActive} setOpenModalNotificacao={setOpenModalNotificacao} notificacoes={notificacoes.length} />
            <div style={{ padding: "30px", background: "#f4f6f8", minHeight: "100vh", marginTop: "64px" }}>
                <div style={{ width: "100%", height: "fit-content", padding: "10px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "20px", marginBottom: "20px" }}>
                        <div style={{ width: "80%" }}>
                            <Breadcrumbs aria-label="breadcrumb">
                                <Link
                                    underline="hover"
                                    sx={{ display: 'flex', alignItems: 'center', cursor: "pointer" }}
                                    color="inherit"
                                    onClick={() => navigate("../Dashboard")}
                                >
                                    <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                    Dashboard
                                </Link>
                                <Typography
                                    sx={{ color: 'text.primary', display: 'flex', alignItems: 'center' }}
                                >
                                    <ReceiptIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                    Notas Fiscais Emitidas
                                </Typography>
                            </Breadcrumbs>
                        </div>
                    </div>
                </div>
                <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <Box sx={{ width: { xs: "90%", md: "80%" }, borderRadius: "8px" }}>
                        <Typography
                            variant="h4"
                            sx={{ fontWeight: 700, mb: 3 }}
                        >
                            Histórico de Notas Fiscais Emitidas
                        </Typography>
                    </Box>
                </Box>
                <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <div style={{ width: window.innerWidth > 768 ? "80%" : "100%", display: "flex", justifyContent: "flex-start", marginBottom: "10px", gap: 10, flexWrap: "wrap" }}>
                        <div style={{ width: window.innerWidth > 768 ? "280px" : "100%", height: "150px", backgroundColor: "#fff", borderRadius: "8px", display: "flex", flexDirection: "column", justifyContent: "space-between", gap: 2, padding: "20px", borderLeft: "4px solid green" }}>
                            <span style={{ display: "flex", flexDirection: "column", gap: 1, fontSize: "12px", fontWeight: 500 }}>
                                TOTAL EMITIDO
                            </span>
                            <span style={{ fontSize: "34px", fontWeight: 700, color: "green" }}>
                                R$ {faturamentoMensal.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </span>
                            <span style={{ display: "flex", alignItems: "center", gap: 1, fontSize: "12px", fontWeight: 500 }}>
                                <AccessTimeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Este mês
                            </span>
                        </div>

                        <div style={{ width: window.innerWidth > 768 ? "280px" : "100%", height: "150px", backgroundColor: "#fff", borderRadius: "8px", display: "flex", flexDirection: "column", justifyContent: "space-between", gap: 2, padding: "20px", borderLeft: "4px solid black" }}>
                            <span style={{ display: "flex", flexDirection: "column", gap: 1, fontSize: "12px", fontWeight: 500 }}>
                                PENDÊNCIAS
                            </span>
                            <span style={{ fontSize: "24px", fontWeight: 700, color: pendencias > 0 ? "#901CB3" : "green" }}>
                                {pendencias ? "Com pendências" : "Sem pendências"}
                            </span>
                            <span style={{ display: "flex", alignItems: "center", gap: 1, fontSize: "12px", fontWeight: 500 }}>
                                <AccessTimeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                {pendencias} pendências fiscais
                            </span>
                        </div>
                    </div>
                </div>
                <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <div
                        style={{
                            width: window.innerWidth > 768 ? "80%" : "100%",
                            margin: "0 auto",
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "16px",
                            backgroundColor: "#fff",
                            borderRadius: "10px",
                            padding: "20px",
                            boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
                            alignItems: "center"
                        }}
                    >
                        {/* Data Inicial */}
                        <div style={{ flex: "1 1 200px", minWidth: "180px" }}>
                            <TextField
                                fullWidth
                                value={dataInicial}
                                onChange={(e) => setDataInicial(e.target.value)}
                                label="Data Inicial"
                                type="date"
                                size="small"
                                InputLabelProps={{ shrink: true }}
                            />
                        </div>

                        {/* Data Final */}
                        <div style={{ flex: "1 1 200px", minWidth: "180px" }}>
                            <TextField
                                fullWidth
                                value={dataFinal}
                                onChange={(e) => setDataFinal(e.target.value)}
                                label="Data Final"
                                type="date"
                                size="small"
                                InputLabelProps={{ shrink: true }}
                            />
                        </div>

                        {/* Status */}
                        <div style={{ flex: "1 1 200px", minWidth: "180px" }}>
                            <FormControl fullWidth size="small">
                                <InputLabel>Status</InputLabel>
                                <Select
                                    label="Status"
                                    value={statusFiltro}
                                    onChange={(e) => setStatusFiltro(e.target.value)}
                                >
                                    <MenuItem value="TODAS">Todas</MenuItem>
                                    <MenuItem value="CONCLUIDO">Emitidas</MenuItem>
                                    <MenuItem value="PENDENTE">Pendentes</MenuItem>
                                    <MenuItem value="CANCELADO">Canceladas</MenuItem>
                                </Select>
                            </FormControl>
                        </div>

                        {/* Botão */}
                        <div
                            style={{
                                flex: "1 1 120px",
                                maxWidth: window.innerWidth > 768 ? "120px" : "100%",
                                display: "flex",
                                justifyContent: "flex-end"
                            }}
                        >
                            <Button
                                variant="contained"
                                fullWidth
                                sx={{
                                    padding: "5px 18px",
                                    backgroundColor: "#9C01B9",
                                    fontSize: "0.9rem",
                                    color: "white",
                                    fontWeight: 800,
                                    transition: "0.3s ease",
                                    '&:hover': {
                                        backgroundColor: "#9C01B9",
                                        boxShadow: "0 4px 10px #9C01B9",
                                    }
                                }}
                                onClick={handleFilter}
                            >
                                Filtrar
                            </Button>
                        </div>
                    </div>
                </div>
                <div style={{ width: window.innerWidth > 768 ? "80%" : "100%", margin: "20px auto" }}>
                    <TableContainer component={Paper} sx={{ borderRadius: "12px" }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell><strong>ID</strong></TableCell>
                                    <TableCell><strong>Número Nfse</strong></TableCell>
                                    <TableCell><strong>Data Emissão</strong></TableCell>
                                    <TableCell><strong>Cliente/Tomador</strong></TableCell>
                                    <TableCell><strong>Valor Bruto</strong></TableCell>
                                    <TableCell><strong>Status</strong></TableCell>
                                    <TableCell align="center"><strong>Ação</strong></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {itemsPaginated?.length > 0 ? (
                                    itemsPaginated?.map((nota, index) => (
                                        <TableRow key={nota.idNota}>
                                            <TableCell>{index + 1}</TableCell>
                                            <TableCell>{nota.numeroNota || "---"}</TableCell>
                                            <TableCell>{FormatDateHour(nota.dataEmissao)}</TableCell>
                                            <TableCell>{nota.dadosNFSe?.tomador || "---"}</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold' }}>R$ {MascaraValor(nota.valor)}</TableCell>
                                            <TableCell sx={{ cursor: 'pointer', fontWeight: 'bold', color: nota.status === 'CONCLUIDO' ? 'green' : nota.status === 'PENDENTE' ? 'orange' : 'red' }}>
                                                <Tooltip title={nota.dadosNFSe ? nota.dadosNFSe.mensagem : ""} arrow>
                                                    {nota.status}
                                                </Tooltip>
                                            </TableCell>
                                            <TableCell align="center">
                                                <div display="flex" alignItems="center" justifyContent="center">
                                                    <Tooltip title="Download PDF">
                                                        <IconButton
                                                            disabled={nota.caminhoPDF ? false : true}
                                                            sx={{ color: '#4caf50' }}
                                                            onClick={() => {
                                                                const apiBase = process.env.REACT_APP_API_URL;
                                                                const url = `${apiBase}/download${nota.caminhoPDF}`;
                                                                window.open(url, '_blank');
                                                            }}
                                                        >
                                                            <CloudDownloadIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Cancelar Nota Fiscal">
                                                        <IconButton
                                                            disabled={nota.status === 'PENDENTE' || nota.status === 'CANCELADO' || nota.status === 'Pedido de Cancelamento' || nota.status === 'REJEITADO' ? true : false}
                                                            sx={{ color: '#f44336' }}
                                                            onClick={() => {
                                                                handleCancelNota(nota.idIntegracao);
                                                            }}

                                                        >
                                                            <CancelIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={9} align="center">
                                            Nenhuma nota fiscal encontrada.
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
                <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "20px" }}>
                    <Pagination count={Math.ceil(filteredNotas?.length / itemsPerPage) || 1}
                        page={currentPage}
                        onChange={(e, value) => setCurrentPage(value)}
                        color="primary" />
                </div>
            </div>
            <ModalNotificacao
                openModalNotificacao={openModalNotificacao}
                onClose={() => setOpenModalNotificacao(false)}
                notificacoes={notificacoes}
            />
            <Loading open={open} />
            <AlertError openSnackbarError={openSnackbarError}
                setOpenSnackbarError={setOpenSnackbarError}
                mensagem={mensagem} />
            <AlertSuccess openSnackbarSuccess={openSnackbarSuccess}
                setOpenSnackbarSuccess={setOpenSnackbarSuccess}
                mensagem={mensagem} />
        </>
    );
};

export default NotasFiscaisEmitidas;
